"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var toteCourseNameMapping = exports.toteCourseNameMapping = {
    "ASCOT": "ASCOT",
    "AYR": "AYR",
    "BANGOR-ON-DEE": "BANGOR",
    "CARLISLE": "CARLISLE",
    "CATTERICK": "CATTERICK",
    "CHELMSFORD": "CHELMSFORD CITY",
    "CHELMSFORD (A.W)": "CHELMSFORD CITY",
    "CHELTENHAM": "CHELTENHAM",
    "CHEPSTOW": "CHEPSTOW",
    "CLONMEL": "CLONMEL",
    "CORK": "CORK",
    "DONCASTER": "DONCASTER",
    "DOWN ROYAL": "DOWN ROYAL",
    "DOWNPATRICK": "DOWNPATRICK",
    "DUNDALK (A.W)": "DUNDALK",
    "EXETER": "EXETER",
    "FAIRYHOUSE": "FAIRYHOUSE",
    "FAKENHAM": "FAKENHAM",
    "FFOS LAS": "FFOS LAS",
    "FONTWELL": "FONTWELL",
    "GOWRAN PARK": "GOWRAN",
    "HAYDOCK": "HAYDOCK PARK",
    "HEREFORD": "HEREFORD",
    "HEXHAM": "HEXHAM",
    "HUNTINGDON": "HUNTINGDON",
    "KELSO": "KELSO",
    "KEMPTON": "KEMPTON PARK",
    "KEMPTON (A.W)": "KEMPTON PARK",
    "LEICESTER": "LEICESTER",
    "LEOPARDSTOWN": "LEOPARDSTOWN",
    "LIMERICK": "LIMERICK",
    "LINGFIELD": "LINGFIELD PARK",
    "LINGFIELD (A.W)": "LINGFIELD PARK",
    "LUDLOW": "LUDLOW",
    "MARKET RASEN": "MARKET RASEN",
    "MUSSELBURGH": "MUSSELBURGH",
    "NAAS": "NAAS",
    "NAVAN": "NAVAN",
    "NEWBURY": "NEWBURY",
    "NEWCASTLE": "NEWCASTLE",
    "NEWCASTLE (A.W)": "NEWCASTLE",
    "PLUMPTON": "PLUMPTON",
    "PUNCHESTOWN": "PUNCHESTOWN",
    "RIPON": "RIPON",
    "SEDGEFIELD": "SEDGEFIELD",
    "SOUTHWELL": "SOUTHWELL",
    "SOUTHWELL (A.W)": "SOUTHWELL",
    "STRATFORD": "STRATFORD",
    "TAUNTON": "TAUNTON",
    "THURLES": "THURLES",
    "TRAMORE": "TRAMORE",
    "UTTOXETER": "UTTOXETER",
    "WARWICK": "WARWICK",
    "WETHERBY": "WETHERBY",
    "WEXFORD": "WEXFORD",
    "WINCANTON": "WINCANTON",
    "WOLVERHAMPTON (A.W)": "WOLVERHAMPTON"
};


//////////////////
// WEBPACK FOOTER
// ./~/rp-prices-component/lib/js/utils/ToteBookmakersNameMap.js
// module id = 2604
// module chunks = 0